window.REBASE = window.REBASE || {};
REBASE.theme = REBASE.theme || {};
REBASE.theme.collection = REBASE.theme.collection || {};


window.pallureToggleQuickView = function pallureToggleQuickView({handle, index, element}) {
  var remainder = index % 3,
    insertIndex = index;

  // remove dom el and bail early if we have no handle
  // this acts as a safeguard against a bad call as well as
  // a method of 'closing' the quickview
  if ( typeof handle === 'undefined' ) {
    $('.product-quickview').remove();
    return false;
    }

  if ( remainder === 1 ) {
    insertIndex = index + 2;
  }

  if ( remainder === 2 ) {
    insertIndex = index + 1;
  }

  // get our new HTML
  fetch(`/products/${handle}?view=quickview`).then((resp) => resp.text())
    .then((html) => {
      if ( element ) {
        $(`.${element}`).after(html)
      } else if ( $('.products .product').length >= insertIndex ) { // if our index is viable, use it
        $(`.products .product:nth-child(${insertIndex})`).after(html);
      } else { // otherwise append to end
        $('.products').append(html);
      }
    })
    .catch((e) => {
      console.error(e)
    })
};

(function($) {
  const removeModal = () => {
    const quickViewModal = document.querySelector('.quickview-modal')
    quickViewModal.remove();
    document.querySelector('body').style.overflow = 'unset';
  }

  $(document).on('click', '.quickview-modal__close', function(e) {
    removeModal();
  });

  $(document).on('click', '.quickview-modal__bg', function(e) {
    removeModal();
  });

  $(document).on('click', '.product__quick-view-button', function(e) {
    var $el = $(this), data = $el.data();
    document.querySelector('body').style.overflow = 'hidden';

    e.preventDefault();
    pallureToggleQuickView({
      handle: data.productHandle,
      index: data.productIndex,
      element: data.targetClass
    });
  });

})(jQuery);
